import React from 'react'

import TribologySamplesInsert from '../../../../components/Tribology/Samples/Insert'

const PageTribologySamplesInsert = () => {
  return <TribologySamplesInsert />
}

export default PageTribologySamplesInsert
